import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ConsentGuard = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="p-10 text-center">Verificare status...</div>;
    }

    // If user is logged in AND has waiting consent status
    // Note: Adjust logic if status string varies (lowercase/uppercase/underscore)
    // Based on backend: 'pending_consimtamant'
    if (user && user.status === 'pending_consimtamant') {
        return <Navigate to="/pending-consent" replace />;
    }

    return children;
};

export default ConsentGuard;
